(function () {
  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector(".header__search");

    let hideMenuTimeout;
    const megaMenuFadeDuration = 180;

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty(
          "--ann-height",
          `${entry.intersectionRect.height}px`
        );
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });
    if (annBar) annBarObserver.observe(annBar);

    const megaMenus = document.querySelectorAll(".mega-menu");

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        clearTimeout(hideMenuTimeout);

        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          if (!megaMenus) return;

          megaMenus.forEach((megaMenu) => {
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.transitionDuration = `${megaMenuFadeDuration}ms`;
              megaMenu.style.opacity = 0;
              megaMenu.style.display = "grid";
              setTimeout(() => {
                megaMenu.style.opacity = 1;
              }, 30);
            }

            const headerMain = header.querySelector(".header");

            const calcPosition = () => {
              megaMenu.style.right = "auto";

              const megaMenuTabs = megaMenu.querySelector(".mega-menu__tabs");

              if (megaMenuTabs) {
                if (megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
                  megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`;
                  megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`;
                }
              }

              const megaMenuRight = megaMenu.getBoundingClientRect().right;
              const headerRight = headerMain.getBoundingClientRect().right;

              if (megaMenuRight > headerRight) {
                megaMenu.style.right = "2rem";
              }
              // TODO: remove this after testing

              if (megaMenu.classList.contains("custom-mega-menu")) {
                megaMenu.style.right = "unset !important";
                const customMegaMenuWidth = megaMenu.offsetWidth;
                megaMenu.style.left = `${
                  1280 - customMegaMenuWidth > 0
                    ? 0
                    : (1280 - customMegaMenuWidth) / 2
                }px `;
              }
            };

            calcPosition();

            let headerMainWidth = headerMain.offsetWidth;

            const resizeObserver = new ResizeObserver((entries) => {
              for (const entry of entries) {
                const newWidth = entry.contentRect.width;

                if (newWidth !== headerMainWidth) {
                  headerMainWidth = newWidth;
                  calcPosition();
                }
              }
            });

            resizeObserver.observe(headerMain);
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
      link.addEventListener("mouseleave", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            if (megaMenu == link.querySelector(".mega-menu")) {
              megaMenu.style.transitionDuration = `${megaMenuFadeDuration}ms`;
              megaMenu.style.opacity = 0;
              hideMenuTimeout = setTimeout(() => {
                megaMenu.style.display = "none";
              }, megaMenuFadeDuration);
            }
          });
        }
      });
      link.addEventListener("focus", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          if (!megaMenus) return;
          megaMenus.forEach((megaMenu) => {
            const megaMenuPositionRight =
              megaMenu.getBoundingClientRect().right;
            const windowRight = window.innerWidth;
            if (megaMenuPositionRight > windowRight) {
              megaMenu.style.right = "0";
            }
          });

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
    });
    menu.addEventListener("mouseleave", (e) => {
      if (!megaMenus) return;
      megaMenus.forEach((megaMenu) => {
        megaMenu.style.transitionDuration = `${megaMenuFadeDuration}ms`;
        megaMenu.style.right = "auto";
        megaMenu.style.opacity = 0;
      });
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.display = "none";
        });
      }, megaMenuFadeDuration);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });
    menu.addEventListener("focusout", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.right = "auto";
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });

    const megaMenuTabs = () => {
      $(".mega-menu__tab-wrapper")
        .children()
        .find(".mega-menu__tab-wrapper")
        .first()
        .addClass("mega-menu__tab-wrapper--active");
      $(".mega-menu__tab-wrapper").mouseenter(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
      $(".mega-menu__tab-wrapper").focus(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
      $(".mega-menu__tab-wrapper").focusin(function (event) {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
      });
    };
    megaMenuTabs();

    // Product tabs mega menu functionality
    const productTabsMegaMenu = () => {
      const productTabsMenus = document.querySelectorAll(
        ".mega-menu--product-tabs"
      );

      productTabsMenus.forEach((menu) => {
        const tabs = menu.querySelectorAll(".product-tabs-mega-left-tab");
        const contents = menu.querySelectorAll(
          ".product-tabs-mega-menu-right-content"
        );
        const viewAllLinks = menu.querySelectorAll(
          ".product-tabs-mega-menu__view-all"
        );

        // Ensure first tab and content are active by default
        if (tabs.length > 0 && contents.length > 0) {
          tabs.forEach((tab, index) => {
            const tabIndex = tab.getAttribute("data-tab-index");

            const switchTab = () => {
              // Remove active class from all tabs
              tabs.forEach((t) => t.classList.remove("active"));
              // Add active class to current tab
              tab.classList.add("active");

              // Hide all contents
              contents.forEach((c) => c.classList.remove("active"));
              // Show corresponding content
              contents.forEach((content) => {
                const contentIndex = content.getAttribute("data-content-index");
                if (contentIndex === tabIndex) {
                  content.classList.add("active");
                }
              });

              // Hide all view-all links
              viewAllLinks.forEach((link) => link.classList.remove("active"));
              // Show corresponding view-all link
              viewAllLinks.forEach((link) => {
                const linkIndex = link.getAttribute("data-view-all-index");
                if (linkIndex === tabIndex) {
                  link.classList.add("active");
                }
              });
            };

            tab.addEventListener("mouseenter", switchTab);
            tab.addEventListener("focus", switchTab);
          });
        }
      });
    };
    productTabsMegaMenu();

    // Mobile Product Tabs Mega Menu - Accordion functionality
    const mobileProductTabsAccordion = () => {
      const mobileProductTabsMenus = document.querySelectorAll(
        ".mega-menu__product-tabs-mb"
      );

      mobileProductTabsMenus.forEach((menu) => {
        const items = menu.querySelectorAll(
          ".mega-menu__product-tabs-mobile-item"
        );

        items.forEach((item) => {
          item.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            // Close all items
            items.forEach((otherItem) => {
              otherItem.classList.remove("active");
            });

            // Toggle current item (if it wasn't active, open it; if it was active, keep it closed)
            if (!isActive) {
              item.classList.add("active");
            }
          });
        });
      });
    };
    mobileProductTabsAccordion();

    // Set custom-search --left and --top CSS variables
    // Similar to custom-mega-menu, custom-search is positioned relative to .header
    // We need to calculate .header's left position and height, then offset custom-search accordingly
    const setCustomSearchPosition = () => {
      const headerMain = document.querySelector(".header");
      const customSearch = document.querySelector(".custom-search");

      if (headerMain && customSearch) {
        // Get .header position and dimensions relative to viewport
        const headerRect = headerMain.getBoundingClientRect();
        const headerLeft = headerRect.left;
        const headerHeight = headerRect.height;

        // Since custom-search is positioned relative to .header (like custom-mega-menu),
        // we need to offset by headerLeft to align it to viewport left edge
        // Set --left to negative of headerLeft (similar to custom-mega-menu's left: min(var(--mega-menu-width), 0))
        customSearch.style.setProperty("--left", `-${headerLeft}px`);

        // Set --top to header height so custom-search appears below the header
        customSearch.style.setProperty("--top", `${headerHeight}px`);
      }
    };

    // Set on document load
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setCustomSearchPosition);
    } else {
      setCustomSearchPosition();
    }

    // Update on window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setCustomSearchPosition, 100);
    });

    // Custom search content visibility logic based on predictive-search__results-list
    const updateCustomSearchContentVisibility = () => {
      const customSearch = document.querySelector(".custom-search");
      if (!customSearch) return;

      const predictiveSearch = customSearch.querySelector("predictive-search");
      const resultsList = customSearch.querySelector(
        ".predictive-search__results-list"
      );
      const customSearchContent = customSearch.querySelector(
        ".custom-search__content"
      );

      if (!predictiveSearch || !customSearchContent) return;

      // Check if results list exists and has content
      const hasResults =
        resultsList &&
        (resultsList.children.length > 0 ||
          resultsList.querySelector(".predictive-search__list-item") !== null ||
          resultsList.textContent.trim().length > 0);

      // Show/hide content based on results
      if (hasResults) {
        customSearchContent.style.display = "none";
      } else {
        customSearchContent.style.display = "block";
      }
    };

    // Initialize custom search visibility logic
    const initCustomSearchVisibility = () => {
      const customSearch = document.querySelector(".custom-search");
      if (!customSearch) return;

      const predictiveSearch = customSearch.querySelector("predictive-search");
      if (!predictiveSearch) return;

      // Initialize visibility
      updateCustomSearchContentVisibility();

      // Use MutationObserver to watch for DOM changes in predictive-search
      const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;

        mutations.forEach((mutation) => {
          // Check if results list was added/removed or modified
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                // Element node
                if (
                  node.classList &&
                  (node.classList.contains("predictive-search__results-list") ||
                    (node.querySelector &&
                      node.querySelector(".predictive-search__results-list")))
                ) {
                  shouldUpdate = true;
                }
              }
            });
            mutation.removedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                node.classList &&
                node.classList.contains("predictive-search__results-list")
              ) {
                shouldUpdate = true;
              }
            });
          }

          // Check if attributes changed (results, loading, open)
          if (
            mutation.type === "attributes" &&
            (mutation.attributeName === "results" ||
              mutation.attributeName === "loading" ||
              mutation.attributeName === "open")
          ) {
            shouldUpdate = true;
          }
        });

        if (shouldUpdate) {
          // Small delay to ensure DOM is fully updated
          setTimeout(updateCustomSearchContentVisibility, 50);
        }
      });

      // Observe changes in the predictive-search element and its children
      observer.observe(predictiveSearch, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["results", "loading", "open"],
      });

      // Also listen for input changes
      const searchInput = customSearch.querySelector('input[type="search"]');
      if (searchInput) {
        let inputTimeout;
        searchInput.addEventListener("input", () => {
          clearTimeout(inputTimeout);
          inputTimeout = setTimeout(updateCustomSearchContentVisibility, 200);
        });

        searchInput.addEventListener("focus", () => {
          setTimeout(updateCustomSearchContentVisibility, 100);
        });

        searchInput.addEventListener("blur", () => {
          setTimeout(updateCustomSearchContentVisibility, 200);
        });
      }

      // Also check periodically as a fallback (in case MutationObserver misses something)
      let checkInterval = setInterval(() => {
        updateCustomSearchContentVisibility();
      }, 1000);

      // Stop interval after 30 seconds (should be enough for initial load)
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 30000);
    };

    // Initialize on load
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initCustomSearchVisibility);
    } else {
      // Small delay to ensure predictive-search is initialized
      setTimeout(initCustomSearchVisibility, 100);
    }

    // Also re-initialize when sections are loaded (Shopify theme editor)
    document.addEventListener("shopify:section:load", () => {
      setTimeout(initCustomSearchVisibility, 200);
    });

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main.querySelectorAll(".shopify-section")[0] &&
      main
        .querySelectorAll(".shopify-section")[0]
        .classList.contains("section--has-overlay")
    ) {
    }

    const menuCloseBtn = document.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = document.querySelector("header-drawer");
    menuCloseBtn.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();
